import type { ConfigObjectMatch } from '@cli-types/next-adapter/init.js'
import { CONFIG_OBJECT_PATTERNS } from '@cli-constants/patterns.js'
import { findMatchingBrace } from '@cli-utils/js-source-scan.js'
import { detectPropertyIndent } from './detect-property-indent.js'

export function findConfigObject(content: string): ConfigObjectMatch | null {
  let openingBrace = -1
  let earliestMatch = Number.POSITIVE_INFINITY

  for (const pattern of CONFIG_OBJECT_PATTERNS) {
    const match = pattern.exec(content)
    pattern.lastIndex = 0
    if (!match) {
      continue
    }

    if (match.index >= earliestMatch) {
      continue
    }

    earliestMatch = match.index
    openingBrace = match.index + match[0].lastIndexOf('{')
  }

  if (openingBrace < 0) {
    return null
  }

  const closingBrace = findMatchingBrace(content, openingBrace)
  if (closingBrace < 0) {
    return null
  }

  return {
    start: openingBrace,
    end: closingBrace,
    propertyIndent: detectPropertyIndent(content, openingBrace)
  }
}
